import { useParams } from "react-router-dom";

import Loading from "web/Layout/Common/Loading";

import {
  useGetAvailableBanksForPrepaidCardQuery,
  useGetPrepaidCardDetailsQuery,
} from "web/features/prepaidCards/prepaidCardsApiSlice";

import ProductPrepaidCard from "./productPrepaidCard";

const Container = () => {
  const { cardId } = useParams();

  const { data: prepaidCardDetails, isLoading } =
    useGetPrepaidCardDetailsQuery(cardId);

  const { data: dataBanks, isLoading: isLoadingBanks } =
    useGetAvailableBanksForPrepaidCardQuery();

  const { financingSources: banks } = dataBanks || {};

  if (isLoading || isLoadingBanks) {
    return <Loading />;
  }

  const banksIds = prepaidCardDetails?.financingSources;
  const activeBanks = banks?.filter(
    ({ id, isBlocked }) => banksIds?.includes(id) && !isBlocked
  );

  const bankTotalPoints =
    activeBanks
      ?.map((item) => Number(item.balance))
      .reduce((prev, next) => prev + next, 0) || 0;

  return (
    <ProductPrepaidCard
      prepaidCard={prepaidCardDetails}
      bankTotalPoints={bankTotalPoints}
    />
  );
};
export default Container;
